import { useTranslation } from 'react-i18next'

import translationKeys from '@translationKeys'

import { AlertFrequencyType } from '@modules/alerts/types'
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { colors } from '@theme/variables'

import { AlertFrequencySelectProps } from '../types'

export const AlertFrequencySelect = ({
  title,
  onSelect,
  disabled,
  selectedAlertFrequency = AlertFrequencyType.NO_NOTIFICATION,
}: AlertFrequencySelectProps) => {
  const { t } = useTranslation()
  return (
    <FormControl variant="outlined" style={{ width: '100%' }}>
      <InputLabel
        sx={{ background: colors.white, padding: '0 6px', marginTop: '2px', color: '#00000099' }}
        id="profile-alert-select"
      >
        {title}
      </InputLabel>
      <Select
        fullWidth
        id="profile-alert-select"
        value={AlertFrequencyType[selectedAlertFrequency] ?? AlertFrequencyType.NO_NOTIFICATION}
        onChange={onSelect}
        disabled={disabled}
      >
        <MenuItem value={AlertFrequencyType.NO_NOTIFICATION}>{t(translationKeys.ALERT_FREQUENCY_NO_NOTIFICATION)}</MenuItem>
        <MenuItem value={AlertFrequencyType.DAILY}>{t(translationKeys.ALERT_FREQUENCY_DAILY)}</MenuItem>
        <MenuItem value={AlertFrequencyType.WEEKLY}>{t(translationKeys.ALERT_FREQUENCY_WEEKLY)}</MenuItem>
      </Select>
    </FormControl>
  )
}
